// JsFromRoutes CacheKey 7bda640c16ce14f81643d9699cd7c6fb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  update: definePathHelper('patch', '/deals/:deal_id/forms/:id'),
}
